import { useEffect } from "react";
import { Link } from "react-router-dom";
import { COMPANY_INFO, SERVICES_LIST } from "../data/siteData";

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "404 - Siden blev ikke fundet | Kærby Tømrer- & Snedkerforretning ApS";
  }, []);

  return (
    <div className="bg-[#f8f7f4] min-h-[75vh] flex items-center justify-center py-20 px-4">
      <div className="max-w-3xl w-full bg-white rounded-2xl border border-[#e2dfd7] shadow-xl p-8 sm:p-12 text-center space-y-8">
        
        {/* Badge / Code */}
        <div className="inline-flex items-center gap-2 bg-[#f4f4f5] border border-[#e4e4e7] px-4 py-1.5 rounded-full text-sm font-bold text-[#d96b27] uppercase tracking-wider">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
          <span>Fejlmeddelelse 404</span>
        </div>

        <div className="space-y-3">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[#16181b] tracking-tight">
            Siden blev desværre ikke fundet
          </h1>
          <p className="text-gray-600 text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
            Den side, du leder efter, kan være flyttet, omdøbt eller eksisterer ikke længere. Benyt navigationsknapperne herunder eller ring til os.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#d96b27] hover:bg-[#c25a1f] text-white font-bold uppercase tracking-wider text-sm sm:text-base px-8 py-3.5 rounded-md shadow-md transition-all"
          >
            <i className="fa-solid fa-house text-sm" aria-hidden="true" />
            <span>Gå til Forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#18181b] hover:bg-[#27272a] text-white font-bold uppercase tracking-wider text-sm sm:text-base px-8 py-3.5 rounded-md shadow-md transition-all"
          >
            <i className="fa-solid fa-envelope text-sm" aria-hidden="true" />
            <span>Kontakt os</span>
          </Link>
        </div>

        {/* Quick Links Suggestions */}
        <div className="pt-8 border-t border-gray-100 space-y-3 text-left">
          <p className="text-xs font-bold text-gray-500 uppercase tracking-wider text-center sm:text-left">
            Måske leder du efter en af vores ydelser?
          </p>
          <div className="flex flex-wrap justify-center sm:justify-start gap-2">
            {SERVICES_LIST.slice(0, 5).map((srv) => (
              <Link
                key={srv.id}
                to={`/${srv.slug}`}
                className="text-xs bg-[#f4f4f5] hover:bg-[#d96b27] hover:text-white text-[#18181b] font-bold uppercase tracking-wider px-3 py-1.5 rounded border border-[#e4e4e7] transition-colors"
              >
                {srv.title}
              </Link>
            ))}
          </div>
        </div>

        <div className="text-xs text-gray-400 pt-2">
          Direkte telefon support:{" "}
          <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-bold text-[#16181b] underline whitespace-nowrap">
            {COMPANY_INFO.phone}
          </a>
        </div>

      </div>
    </div>
  );
}
